(() => {
  'use strict';
  if (window.__gnwStudioV6) return;
  window.__gnwStudioV6 = true;
  const selector = '[data-gnw-audience]';
  // Native details works without JavaScript. Add only outside/Escape dismissal.
  document.addEventListener('click', event => {
    document.querySelectorAll(`${selector}[open]`).forEach(group => {
      if (!group.contains(event.target)) group.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const group = event.target.closest && event.target.closest(`${selector}[open]`);
    if (group) { event.preventDefault(); group.open = false; group.querySelector('summary').focus(); }
  });
  document.addEventListener('toggle', event => {
    if (!event.target.matches || !event.target.matches(selector) || !event.target.open) return;
    document.querySelectorAll(`${selector}[open]`).forEach(group => { if (group !== event.target) group.open = false; });
  }, true);
  let frame;
  const fitHeader = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const header = document.getElementById('SiteHeader');
      if (!header) return;
      header.removeAttribute('data-gnw-compact-menu');
      if (innerWidth < 1200) return;
      const nav = header.querySelector('.header-layout--left-center .header-item--navigation');
      const list = nav && nav.querySelector('.site-navigation');
      if (!nav || !list || !nav.clientWidth) return;
      if (list.scrollWidth > nav.clientWidth + 2) header.setAttribute('data-gnw-compact-menu','true');
    });
  };
  addEventListener('resize',fitHeader,{passive:true});
  document.addEventListener('shopify:section:load',fitHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',fitHeader,{once:true}); else fitHeader();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHeader);
})();
